import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Sleep = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sleep icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 1C26 0.447715 26.4477 0 27 0L45 0C45.4044 0 45.7691 0.243642 45.9238 0.617317C46.0786 0.990991 45.9931 1.42111 45.7071 1.70711L28.4142 19H45C45.5523 19 46 19.4477 46 20C46 20.5523 45.5523 21 45 21H26C25.5955 21 25.2309 20.7564 25.0761 20.3827C24.9213 20.009 25.0069 19.5789 25.2929 19.2929L42.5858 2H27C26.4477 2 26 1.55228 26 1ZM2.99996 14C2.99996 13.4477 3.44768 13 3.99996 13H17C17.3982 13 17.7584 13.2362 17.9171 13.6015C18.0758 13.9667 18.0027 14.3912 17.731 14.6823L5.30118 28H18C18.5522 28 19 28.4477 19 29C19 29.5523 18.5522 30 18 30H2.99996C2.60176 30 2.24151 29.7638 2.08281 29.3985C1.92411 29.0333 1.99721 28.6088 2.26891 28.3177L14.6987 15H3.99996C3.44768 15 2.99996 14.5523 2.99996 14ZM20 35C19.4477 35 19 35.4477 19 36C19 36.5523 19.4477 37 20 37H27.5858L18.2929 46.293C18.0069 46.579 17.9213 47.0091 18.0761 47.3828C18.2309 47.7565 18.5955 48.0001 19 48.0001H29C29.5523 48.0001 30 47.5524 30 47.0001C30 46.4478 29.5523 46.0001 29 46.0001H21.4142L30.7071 36.7071C30.9931 36.4211 31.0786 35.991 30.9238 35.6173C30.7691 35.2436 30.4044 35 30 35H20Z"
    />
  </svg>
)
